/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { LegacyReferralReportViewModel } from './LegacyReferralReportViewModel'; 

export function getLegacyReferralReportOptions(from: string, to: string, onSuccess?: (result: LegacyReferralReportViewModel) => void) {
	return queryOptions({
		queryKey: ['legacy-referral-report', from, to],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/legacy/referrals/queries/getlegacyreferralreport/' + from + '/' + to;
			const resp = await axios.get<LegacyReferralReportViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(from) && Boolean(to)
	});
}